export enum SessionType {
  PAGE_VISIT = 'page-visit',
  FORM = 'form',
  SURVEY = 'survey',
  QUIZ = 'quiz',
  APPOINTMENT = 'appointment',
  APPOINTMENT_V3 = 'appointment_v3',
  TRIGGER_LINK = 'trigger-link',
  CONTACT_CREATED = 'contact-created',
  CALL = 'call',
  ONE_STEP_CONTACT = 'one-step-contact',
  TWO_STEP_CONTACT = 'two-step-contact',
  ONE_STEP_PAY = 'one-step-pay',
  TWO_STEP_PAY = 'two-step-pay',
  FB_LEAD_FORM = 'fb-lead-form',
  CHAT_WIDGET_FORM = 'chat-widget-form',
  LINKEDIN_LEAD_FORM = 'linkedin-lead-form',
}
